<script lang="ts">
    export let icon: string,
        title: string,
        content: string[] = [],
        noMargin = false

    //
</script>

<div
    class="card"
    class:noMargin="{noMargin}"
>
    <div class="cardHeader">
        <div class="icon">
            <img
                src="../../../assets/icons/{icon}"
                alt="icon"
            />
        </div>
        {#if title}
            <h1>{title}</h1>
        {:else}
            <ul class="content">
                {#each content as entry}
                    <li class="contentTextBold">
                        {entry}
                    </li>
                {/each}
            </ul>
        {/if}
    </div>
    <slot />
</div>

<style lang="less">
    @import "../../../assets/variables.less";
    .card {
        border-radius: 0.6rem;
        border: 1px solid var(--grey-300);
        display: flex;
        padding: 2px 0px;
        flex-direction: column;
        align-items: center;
        position: relative;
        width: 100%;
        overflow: hidden;
        .noMargin {
            margin-left: 0px !important;
            margin-right: 0px !important;
        }
        .cardHeader {
            background: var(--white-100);
            padding: 1.2rem;
            display: flex;
            flex-direction: column;
            @media @mobile {
                flex-direction: row;
                align-items: center;
            }

            gap: 0.6rem;
            box-shadow: var(--input-active-box-shadow);
            width: 100%;
            .icon {
                width: 1.6rem;
                height: 1.6rem;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                }
            }
            .content {
                display: flex;
                align-items: center;

                li {
                    border-left: 1px solid var(--text-100);
                    padding: 0px 0.6rem;
                    height: fit-content;
                    font-size: var(--headlines-h2-font-size);
                    font-weight: 400;
                    font-family: Inter-Regular;
                    line-height: 1.6rem;
                    color: var(--text-100);
                    &:first-child {
                        border-left: none;
                        padding-left: 0px;
                    }
                }
                @media @mobile {
                    flex-direction: column;
                    align-items: flex-start;
                    li {
                        border-left: none;
                        padding-left: 0px;
                        padding-top: 0rem;
                        font-size: 1.2rem;
                        &:first-child {
                            padding-top: 0px;
                        }
                    }
                }
            }
        }
    }
</style>
